import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
/* eslint-disable react/prop-types,jsx-a11y/anchor-is-valid */
// Defined in general.js
/* global dcAnalytics */
import PureRenderMixin from '../common/external-adapters/pureRenderMixinAdapter.js';

import { isChildFilterSelected, essentialsListSearchOnly, hasNonEssentialsFilters, ESSENTIALS_LIST_PARAM_NAMES } from '../common/searchRequestUtils.js';
import PickAProject from './pickAProject.js';
import useFullyFundedFilter from './useFullyFundedFilter.js';
import makeParams from './makeParams.js';
import GiveWidgetToggle from '../common/GiveWidgetToggle.js';
import FullyFundedFilterToggle from './FullyFundedFilterToggle.js';
import { Svg } from '../common/Svg.js';
import { decodeXml } from '../utils/encodeXML.ts';

let Filters = (props) => {
    const {
        isMobile, followList, searchURL, projects, filterCategories, extraFilters,
        mapFeatureCallout, showGiveWidget, callbacks,
    } = props;
    const [isExpanded, setExpanded] = React.useState(isMobile);
    const [checkFullyFundedFilter, toggleFullyFundedFilter] = useFullyFundedFilter(props);

    const makeFilterSections = function (filters) {
        return filters.map(function (category) {
            // Each category object has a single key that represents the title of the category
            const title = Object.keys(category)[0];
            return <FilterSection {...props} title={title} filters={category[title]} key={title}/>;
        });
    };

    const makeFollowList = function () {
        if (followList && (followList.searches || followList.favoriteTeachers)) {
            return <FollowList {...props} />;
        }
    };

    const makePickAProject = function () {
        const url = new Uri(searchURL);
        const showPickAProject = !isMobile &&
            !url.hasQueryParam('historical', 'true') && (projects.totalProposals > 1);
        if (showPickAProject) {
            return <PickAProject searchURL={searchURL}/>;
        }
    };

    const toggle = function (event) {
        setExpanded(!isExpanded);
        event.preventDefault();
    };

    const sections = makeFilterSections(filterCategories);
    if (mapFeatureCallout) {
        // We can't check the feature flag here directly because of caching (that is: the filter-list-contents
        // are not guaranteed to match the current feature-flag-value). So instead we have to hackily check for the
        // presence of an essentials-list-filter.
        const includesEssentialsLists = sections.length > 1 && sections[1].key === 'Gift the essentials';

        const mapIndex = includesEssentialsLists ? 2 : 1;
        sections.splice(mapIndex, 0, mapFeatureCallout);
    }
    let extraSections;
    if (isExpanded) {
        extraSections = makeFilterSections(extraFilters);
    }

    let extraSectionToggle;
    if (!isMobile) {
        const toggleIcon = isExpanded ? 'icon-hyphen' : 'icon-plus';
        extraSectionToggle = (
            <a className="more-filters-link" href="#" onClick={toggle} rel="nofollow">
                <svg className={`icon ${toggleIcon}`}>
                    <use xlinkHref={`/images/icon/icon-junior.svg#${toggleIcon}`}></use>
                </svg>
                {isExpanded ? 'Hide' : 'Show'} school type
            </a>
        );
    }

    return (
        <div>
            {makeFollowList()}
            {sections}
            {extraSectionToggle}
            {extraSections}
            {makePickAProject()}
            <FullyFundedFilterToggle toggle={toggleFullyFundedFilter} applyFilters={callbacks.applyFilters} on={checkFullyFundedFilter} />
            <GiveWidgetToggle on={showGiveWidget} toggle={callbacks.toggleGiveWidget} />
        </div>
    );
};
Filters = React.memo(Filters);
export default Filters;

let FilterSection = (props) => {
    const { isMobile, title, searchURL, filters } = props;
    const [isExpanded, setExpanded] = React.useState(!isMobile);

    const titleClass = title.replace(/ /g, '-').toLowerCase();

    const toggle = function (event) {
        setExpanded(!isExpanded);
        event.preventDefault();
    };

    const url = new Uri(searchURL);
    const isSelected = filter => url.hasQueryParam(filter.paramName, filter.value);

    // If a filter section is minimized and there are more than 4 possible filters,
    // only display the first 3, unless some filters that would be hidden are checked.
    // We want to ensure the user sees filters that have been selected.
    let filterData = filters;

    // If we're only searching for essentials, hide irrelevant filters
    if (essentialsListSearchOnly(searchURL)) {
        filterData = filterData.filter(({ paramName }) => ESSENTIALS_LIST_PARAM_NAMES.includes(paramName));

        if (filterData.length === 0) {
            return null;
        }
    }

    let extraFiltersToggle;
    const collapsedFilterLength = 3;
    const enoughFiltersToExpand = filterData.length > collapsedFilterLength + 1;

    if (enoughFiltersToExpand && isMobile) {
        const collapsedFiltersSelected = filterData.slice(collapsedFilterLength)
            .some(filter =>
                isSelected(filter) || (filter.children || []).some(isSelected),
            );

        if (collapsedFiltersSelected) {
            if (!isExpanded) {
                setExpanded(true);
            }
        } else {
            if (!isExpanded) {
                filterData = filterData.slice(0, collapsedFilterLength);
            }

            const toggleIcon = isExpanded ? 'icon-hyphen' : 'icon-plus';
            extraFiltersToggle = (
                <a className="more-filters-link" href="#" onClick={toggle} rel="nofollow">
                    <svg className={`icon ${toggleIcon}`}>
                        <use xlinkHref={`/images/icon/icon-junior.svg#${toggleIcon}`}></use>
                    </svg>
                    Show {isExpanded ? 'less' : 'more'}
                </a>
            );
        }
    }

    const sectionClass = 'form-redux filter-group ' + titleClass;
    const inputType = titleClass === 'amount-needed' ? 'radio' : 'checkbox';
    const filterList = filterData.map((filter) =>
        <Filter {...props} {...filter} inputType={inputType} key={filter.key}/>,
    );

    return (
        <div className={sectionClass}>
            <h4>{title}</h4>
            {filterList}
            {extraFiltersToggle}
        </div>
    );
};
FilterSection = React.memo(FilterSection);

const Filter = createReactClass({
    mixins: [PureRenderMixin],

    isSelected: function () {
        const props = this.props;
        const url = new Uri(props.searchURL);
        return url.hasQueryParam(props.paramName, props.value);
    },

    makeChildren: function () {
        return <ChildFilters {...this.props} />;
    },

    makeFilteredUrl: function () {
        return this.props.callbacks.makeSearchURL(makeParams(this.props.paramName, this.props.value, this.isSelected()));
    },

    setFilter: function (event) {
        this.props.callbacks.applyFilters(makeParams(this.props.paramName, this.props.value, this.isSelected()));
        event.preventDefault();
    },

    /**
     * returns facet count, or undefined if there is no count for this facet
     */
    getFacetCount: function () {
        let name = this.props.text;
        let category = this.props.paramName;
        const value = this.props.value;

        // For the pilot, we aren't supporting real facet counts for the essentials endpoint.
        // We're mocking the counts for now.
        if (essentialsListSearchOnly(this.props.searchURL)) {
            return ESSENTIALS_LIST_PARAM_NAMES.includes(category) ? 1 : 0;
        }

        const counts = this.props.facetCounts;
        if (!counts) {
            return 0;
        }

        // Our API returns facet counts in some weird formats, so here are special cases
        if (category === 'historical' || category === 'hasProposalPhotos') {
            return undefined;
        } else if (category === 'essentialsListsOnly') {
            // Only enable the essentials filter if the current filters are compatible with it
            return hasNonEssentialsFilters(this.props.searchURL) ? 0 : 1;
        } else if (category.indexOf('NotFunded') > -1 || category.indexOf('equityFocus') > -1) {
            return counts[category];
        } else if (category.indexOf('subject') > -1) {
            category = 'subject';
        } else if (category === 'partiallyFunded') {
            name = (value === 'no') ? 'None yet' : 'Some received';
        } else if (category.indexOf('matching') > -1) {
            category = 'matching';
        }

        return counts[category][name];
    },

    render: function () {
        const props = this.props;
        const url = new Uri(props.searchURL);
        const isSelected = this.isSelected();
        const filteredUrl = this.makeFilteredUrl();
        const count = parseInt(this.getFacetCount());

        let isChildSelected, children;
        if (props.children) {
            isChildSelected = isChildFilterSelected(props.children, url);
            if (isSelected || isChildSelected) {
                children = this.makeChildren();
            }
        }

        return (
            <FacetLayout {...props} href={filteredUrl} action={this.setFilter}
                isSelected={isSelected} children={children} count={count}
                isChildSelected={isChildSelected}/>
        );
    },
});

let ChildFilters = (props) => {
    const filters = props.children.map(function (filter) {
        const key = 'child' + filter.key;
        return <Filter {...props} children={null} {...filter} key={key}/>;
    });

    return (
        <div className="filter-children">
            {filters}
        </div>
    );
};
ChildFilters = React.memo(ChildFilters);

const FollowList = createReactClass({
    mixins: [PureRenderMixin],

    getInitialState: function () {
        return {
            loading: false,
        };
    },

    UNSAFE_componentWillReceiveProps: function () {
        this.setState({
            loading: false,
        });
    },

    showMoreSearches: function (event) {
        this.setState({
            loading: true,
        });
        this.props.callbacks.loadFollowList(true);
        event.preventDefault();
    },

    makeMoreSearches: function () {
        if (this.state.loading) {
            return (
                <div key="waiting-more-searches">
                    <div className="loader">
                        <div className="dot one"></div>
                        <div className="dot two"></div>
                        <div className="dot three"></div>
                    </div>
                </div>
            );
        } else {
            return (
                <a key="load-more-searches" className="load-more-searches" href="#" onClick={this.showMoreSearches}>
                    <Svg icon="plus" attributes={{ role: 'presentation' }}/>
                    Show more
                </a>
            );
        }
    },

    render: function () {
        const props = this.props;
        const favoriteFilters = [];
        const favorites = props.followList;
        const favoriteTeachers = favorites.favoriteTeachers;

        if (favoriteTeachers) {
            const allSearchString = 'favoriteTeachers=' + favoriteTeachers.id;
            favoriteFilters.push(
                <Favorite {...props} trackingName="All Teachers"
                    text="Teachers & schools you follow" numFound={favoriteTeachers.numFound}
                    searchString={allSearchString} key="favorites-teachers-schools"/>,
            );
        }

        if (favorites.searches) {
            favorites.searches.forEach(function (search) {
                const searchString = new Uri(search.searchURL).query();
                favoriteFilters.push(<Favorite {...props} trackingName="Search" text={search.searchDesc}
                    numFound={search.numFound} searchString={searchString}
                    key={searchString}/>);
            });

            if (favorites.moreSearches) {
                favoriteFilters.push(this.makeMoreSearches());
            }
        }

        return (
            <div className="form-redux filter-group saved-searches">
                <h4 className='favorites-title'>Saved Searches</h4>
                {favoriteFilters}
            </div>
        );
    },
});

const Favorite = createReactClass({
    mixins: [PureRenderMixin],

    isSelected: function () {
        return this.props.searchURL.indexOf(this.props.searchString) > -1;
    },

    makeHref: function () {
        return this.props.externalLink || new Uri(this.props.baseSearchURL).setQuery(this.props.searchString).toString();
    },

    onclick: function (event) {
        const props = this.props;
        dcAnalytics.trackEventGA([pageName, 'Follow Sidebar', 'Click - ' + props.trackingName]);

        if (props.searchString) {
            const newURL = this.isSelected() ? props.baseSearchURL : this.makeHref();
            props.callbacks.changeURL(newURL);
            event.preventDefault();
        }
        // If it's an external link, fall through to the href
    },

    render: function () {
        const props = this.props;
        const selected = this.isSelected();
        const text = decodeXml(props.text).replace(/>/g, '+');

        return (
            <FacetLayout isMobile={props.isMobile} href={this.makeHref()} text={text} inputType="radio"
                action={this.onclick} isSelected={selected} count={parseInt(props.numFound, 10)}/>
        );
    },
});

const FacetLayout = createReactClass({
    propTypes: {
        isMobile: PropTypes.bool.isRequired,
        text: PropTypes.string.isRequired,
        action: PropTypes.func.isRequired,
        isSelected: PropTypes.bool.isRequired,
        href: PropTypes.string.isRequired,

        count: PropTypes.number,
        children: PropTypes.element,
        isChildSelected: PropTypes.bool,
        faq: PropTypes.object,
        tooltipText: PropTypes.string,
        gaEventAction: PropTypes.string,
        gaEventLabel: PropTypes.string,
        inputType: PropTypes.string,
        active: PropTypes.bool,
    },

    getDefaultProps: function () {
        return {
            active: true,
        };
    },

    // Intentionally omitting PureRenderMixin here because the filters need to refresh to display the check box correctly

    onClick: function (event) {
        const props = this.props;
        if (props.count === 0 && !props.isSelected) {
            // Disable links if there won't be results
            event.preventDefault();
            return;
        }
        if (props.gaEventLabel && props.gaEventAction) {
            dcAnalytics.trackEventGA([pageName, props.gaEventLabel, props.gaEventAction]);
        }
        dcAnalytics.trackOptX('filterApplied');
        props.action(event);
    },

    render: function () {
        const props = this.props;
        let linkClass = 'filter-name';
        let checkboxClass = 'checkbox-holder';

        if (props.paramName) {
            // eslint-disable-next-line no-control-regex
            const paramClass = props.paramName.replace(/[^\x00-\x7F]/g, '').toLowerCase();
            linkClass += ' ' + paramClass;
            checkboxClass += ' ' + paramClass;
        }

        if (props.isChildSelected) {
            linkClass += ' selected indeterminate';
        } else if (props.isSelected) {
            linkClass += ' selected';
        } else if (props.count === 0) {
            linkClass += ' no-results';
        }

        if (!props.active) {
            linkClass += ' inactive';
        }

        // If count is undefined/NaN, we don't add any special styling

        let tooltip = '';
        if (!props.isMobile) {
            if (props.faq) {
                tooltip = <Tooltip text={props.faq.answer}/>;
            } else if (props.tooltipText) {
                tooltip = <Tooltip text={props.tooltipText}/>;
            }
        }

        return (
            <div className={checkboxClass}>
                <a href={props.href} className={linkClass} onClick={this.onClick} role={props.inputType}
                    dangerouslySetInnerHTML={{ __html: props.text }}></a>
                {tooltip}
                {props.children}
            </div>
        );
    },
});

const Tooltip = createReactClass({
    propTypes: {
        text: PropTypes.string.isRequired,
    },
    mixins: [PureRenderMixin],

    render: function () {
        const props = this.props;
        return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            <span className="tooltip-wrapper" tabIndex="0">
                <svg className="icon icon-help"><use xlinkHref="/images/icon/icon-junior.svg#icon-help"></use></svg>
                <span className="hover-tooltip">
                    <div dangerouslySetInnerHTML={{ __html: props.text }}></div>
                </span>
            </span>
        );
    },
});
